<div class="op-page">
  <!-- Breadcrumb -->
  <nav class="op-crumb">
    <span class="op-crumb-link" (click)="navigateToVendorDashboard()">{{ VendorManagementEnum.VendorManagement }}</span>
    <span class="op-sep">›</span>
    <span class="op-here">{{ activeTab === tabLabel.OpenPositions ? VendorManagementEnum.OpenPositions : VendorManagementEnum.Candidates }}</span>
  </nav>

  <div class="op-card">
    <!-- Custom tabs -->
    <div class="op-tabs" role="tablist">
      <button
        class="op-tab"
        role="tab"
        [class.active]="activeTab === tabLabel.OpenPositions"
        (click)="selectTab(tabLabel.OpenPositions)"
      >
        {{ tabLabel.OpenPositions }}
        <span class="op-badge">{{ positionCount }}</span>
      </button>
      <button
        class="op-tab"
        role="tab"
        [class.active]="activeTab === tabLabel.Candidates"
        (click)="selectTab(tabLabel.Candidates)"
      >
        {{ tabLabel.Candidates }}
        <span class="op-badge">{{ candidatesCount }}</span>
      </button>
    </div>

    <!-- ===================== OPEN POSITIONS TAB ===================== -->
    <ng-container *ngIf="activeTab === tabLabel.OpenPositions">
      <!-- Toolbar -->
      <div class="op-toolbar">
        <div class="op-search">
          <emerald-icon class="op-search-ic">search</emerald-icon>
          <input
            type="text"
            [value]="filterValue"
            (keyup)="searchItem($event)"
            placeholder="Search job title, position ID…"
            aria-label="Search open positions"
          />
          <button
            *ngIf="filterValue?.length && filterValue.length > 0"
            class="op-search-clear"
            (click)="clearInput()"
            aria-label="Clear search"
          >✕</button>
        </div>
        <div class="op-chips" *ngIf="hasActiveFilters">
          <span class="op-chip" *ngIf="activeFilters.status && activeFilters.status !== 'Open'">Status: <b>{{ activeFilters.status }}</b></span>
          <span class="op-chip" *ngIf="activeFilters.lob">LOB: <b>{{ activeFilters.lob }}</b></span>
          <span class="op-chip" *ngIf="activeFilters.leader">Leader: <b>{{ activeFilters.leader }}</b></span>
          <span class="op-chip" *ngIf="activeFilters.location">Location: <b>{{ activeFilters.location }}</b></span>
          <span class="op-chip" *ngIf="activeFilters.jobTitle">Job: <b>{{ activeFilters.jobTitle }}</b></span>
          <span class="op-chip" *ngIf="activeFilters.openedDate">Opened ≥ <b>{{ activeFilters.openedDate }}</b></span>
          <span class="op-chip" *ngIf="activeFilters.desiredStartDate">Start ≥ <b>{{ activeFilters.desiredStartDate }}</b></span>
        </div>
        <div class="op-spacer"></div>
        <div class="op-filter-slot">
          <button class="op-filterbtn" (click)="toggleFilterPanel()">
            <emerald-icon>filter_list</emerald-icon> Filters
            <span class="op-filter-count" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
          </button>
          <div class="op-filter-backdrop" *ngIf="showFilterPanel" (click)="showFilterPanel = false"></div>
          <div class="op-filter-panel" *ngIf="showFilterPanel">
            <div class="op-fp-head">Filter open positions</div>
            <div class="op-fp-row">
              <label class="op-fp-label">Status</label>
              <div class="op-fp-checks">
                <label class="op-fp-check" *ngFor="let s of statusOptions">
                  <input type="checkbox" [checked]="filterDraft.status.includes(s)" (change)="toggleStatus(s)" />
                  {{ s }}
                </label>
              </div>
            </div>
            <div class="op-fp-row">
              <label class="op-fp-label">LOB</label>
              <select class="op-fp-field" [(ngModel)]="filterDraft.lob">
                <option value="">All</option>
                <option *ngFor="let v of facetLob" [value]="v">{{ v }}</option>
              </select>
            </div>
            <div class="op-fp-row">
              <label class="op-fp-label">ID&amp;T Leader</label>
              <select class="op-fp-field" [(ngModel)]="filterDraft.leader">
                <option value="">All</option>
                <option *ngFor="let v of facetLeader" [value]="v">{{ v }}</option>
              </select>
            </div>
            <div class="op-fp-row">
              <label class="op-fp-label">Location</label>
              <select class="op-fp-field" [(ngModel)]="filterDraft.location">
                <option value="">All</option>
                <option *ngFor="let v of facetLocation" [value]="v">{{ v }}</option>
              </select>
            </div>
            <div class="op-fp-row">
              <label class="op-fp-label">Job Title</label>
              <select class="op-fp-field" [(ngModel)]="filterDraft.jobTitle">
                <option value="">All</option>
                <option *ngFor="let v of facetJobTitle" [value]="v">{{ v }}</option>
              </select>
            </div>
            <div class="op-fp-row">
              <label class="op-fp-label">Opened on or after</label>
              <input class="op-fp-field" type="date" [(ngModel)]="filterDraft.openedDate" />
            </div>
            <div class="op-fp-row">
              <label class="op-fp-label">Desired start on or after</label>
              <input class="op-fp-field" type="date" [(ngModel)]="filterDraft.desiredStartDate" />
            </div>
            <div class="op-fp-actions">
              <button class="op-fp-reset" (click)="resetFilterPanel()">Reset</button>
              <button class="op-fp-apply" (click)="applyFilterPanel()">Apply</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="op-table-wrap" *ngIf="displayData.length > 0; else noData">
        <table class="op-table">
          <colgroup>
            <col style="width:6%" /><col style="width:16%" /><col style="width:6%" />
            <col style="width:10%" /><col style="width:12%" /><col style="width:9%" />
            <col style="width:8%" /><col style="width:6%" /><col style="width:7%" />
            <col style="width:6%" /><col style="width:14%" />
          </colgroup>
          <thead>
            <tr>
              <th class="sortable" (click)="sortBy('hiringRequestId')" (mouseenter)="showTip($event, 'Position ID')" (mouseleave)="hideTip()">Pos ID <span class="op-sort" [ngClass]="sortIndicator('hiringRequestId')"></span></th>
              <th class="sortable" (click)="sortBy('jobTitle')" (mouseenter)="showTip($event, 'Job Title')" (mouseleave)="hideTip()">Job Title <span class="op-sort" [ngClass]="sortIndicator('jobTitle')"></span></th>
              <th class="c sortable" (click)="sortBy('numberOfPositions')" (mouseenter)="showTip($event, 'Positions')" (mouseleave)="hideTip()">Positions <span class="op-sort" [ngClass]="sortIndicator('numberOfPositions')"></span></th>
              <th class="sortable" (click)="sortBy('lobName')" (mouseenter)="showTip($event, 'LOB')" (mouseleave)="hideTip()">LOB <span class="op-sort" [ngClass]="sortIndicator('lobName')"></span></th>
              <th class="sortable" (click)="sortBy('dntLeaderName')" (mouseenter)="showTip($event, 'ID&T Leader')" (mouseleave)="hideTip()">ID&amp;T Leader <span class="op-sort" [ngClass]="sortIndicator('dntLeaderName')"></span></th>
              <th class="sortable" (click)="sortBy('location')" (mouseenter)="showTip($event, 'Location')" (mouseleave)="hideTip()">Location <span class="op-sort" [ngClass]="sortIndicator('location')"></span></th>
              <th class="sortable" (click)="sortBy('createdDate')" (mouseenter)="showTip($event, 'Opened date')" (mouseleave)="hideTip()">Opened <span class="op-sort" [ngClass]="sortIndicator('createdDate')"></span></th>
              <th class="sortable" (click)="sortBy('ageOld')" (mouseenter)="showTip($event, 'Aging')" (mouseleave)="hideTip()">Aging <span class="op-sort" [ngClass]="sortIndicator('ageOld')"></span></th>
              <th class="sortable" (click)="sortBy('status')" (mouseenter)="showTip($event, 'Status')" (mouseleave)="hideTip()">Status <span class="op-sort" [ngClass]="sortIndicator('status')"></span></th>
              <th class="c sortable" (click)="sortBy('noOfCandidates')" (mouseenter)="showTip($event, 'Profiles received')" (mouseleave)="hideTip()">Profiles <span class="op-sort" [ngClass]="sortIndicator('noOfCandidates')"></span></th>
              <th class="r">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of displayData; trackBy: trackByIndex">
              <td class="mono muted">{{ row.hiringRequestId }}</td>
              <td>
                <span class="op-jt-wrap">
                  <emerald-icon
                    *ngIf="isRowPriority(row)"
                    class="op-jt-flag"
                    [icon]="priority.flag"
                    [color]="priority.red"
                    [type]="'outlined'"
                    title="High priority"
                  ></emerald-icon>
                  <a
                    class="op-jt op-tip-txt {{ row.hiringRequestId }}"
                    (mouseenter)="showTip($event, row.jobTitle)"
                    (mouseleave)="hideTip()"
                    (click)="navigateToJobDetails(row)"
                  >{{ row.jobTitle }}</a>
                </span>
              </td>
              <td class="c"><span class="op-posnum">{{ row.numberOfPositions }}</span></td>
              <td (mouseenter)="showTip($event, row.lobName)" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ row.lobName }}</span></td>
              <td (mouseenter)="showTip($event, row.dntLeaderName)" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ row.dntLeaderName }}</span></td>
              <td (mouseenter)="showTip($event, row.location)" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ row.location }}</span></td>
              <td class="mono muted">{{ row.createdDate | date: dateFormat.Month }}</td>
              <td>
                <span class="op-age" [ngClass]="agingClass($any(row).ageOld)">{{ $any(row).ageOld }}d</span>
              </td>
              <td>
                <span class="op-pill" [ngClass]="statusClass(row.status)">
                  <span class="dot"></span>{{ row.status }}
                </span>
              </td>
              <td class="c"><span class="op-cand">{{ row.noOfCandidates }}</span></td>
              <td class="r op-cell-actions">
                <div class="op-actions">
                  <button
                    *ngIf="row.jobDescriptionPath"
                    class="op-iconbtn"
                    title="Download job description"
                    (click)="downloadJobDescription(row.jobTitle, row.jobDescriptionPath)"
                  >
                    <emerald-icon>download</emerald-icon>
                  </button>
                  <button
                    class="op-rowbtn primary"
                    [disabled]="row.status !== 'Open'"
                    (click)="getCandidateInfor(row.hiringRequestId, row.jobTitle, row.location)"
                  >
                    <emerald-icon>add</emerald-icon> Add Profile
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #noData>
        <section class="op-empty" aria-label="Records section">
          <ng-container *ngIf="isDataLoaded; else loadingState">
            <h2 class="op-empty-title">No Records Found</h2>
            <img [src]="imageSrc" alt="No records illustration" class="op-empty-img" />
          </ng-container>
          <ng-template #loadingState>
            <h2 class="op-empty-title op-loading-title">Loading open positions…</h2>
          </ng-template>
        </section>
      </ng-template>

      <!-- Pagination footer -->
      <div class="op-tfoot" *ngIf="displayData.length > 0">
        <div class="op-info">
          Showing <b>{{ rangeStart }}–{{ rangeEnd }}</b> of <b>{{ positionCount }}</b> open positions
        </div>
        <div class="op-pager">
          <button class="pg" (click)="prevPage()" [disabled]="currentPageValue === 1" aria-label="Previous page">‹</button>
          <button
            *ngFor="let p of pageWindow; trackBy: trackByIndex"
            class="pg"
            [class.on]="p === currentPageValue"
            [disabled]="p === -1"
            (click)="goToPage(p)"
          >{{ p === -1 ? '…' : p }}</button>
          <button class="pg" (click)="nextPage()" [disabled]="currentPageValue >= totalPages" aria-label="Next page">›</button>
        </div>
        <div class="op-psize">
          <span>Rows</span>
          <select [value]="pageSizeValue" (change)="onPageSizeChange($event)" aria-label="Rows per page">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="20">20</option>
          </select>
        </div>
      </div>

      <!-- Add candidate flow (unchanged) -->
      <app-add-candidate
        (updateState)="resetActions($event)"
        [edit]="edit"
        (candidateUpdated)="receiveData($event, candidateId)"
        [fieldsVisibility]="fieldsVisibility"
        [hiringRequestId]="candidateId"
        [jobTitle]="jobTitle"
        [jobLocation]="location"
      ></app-add-candidate>

      <app-open-positions-flag-legend [legendItems]="legendItems"></app-open-positions-flag-legend>
    </ng-container>

    <!-- ===================== CANDIDATES TAB ===================== -->
    <app-candidates *ngIf="activeTab === tabLabel.Candidates"></app-candidates>
  </div>

  <!-- Job details modal (unchanged) -->
  <app-modal-wrapper *ngIf="showJobDetails" [showModal]="showJobDetails">
    <app-vendor-rep-job-details
      [openPositionData]="selectedJob"
      (close)="showJobDetails = false"
    ></app-vendor-rep-job-details>
  </app-modal-wrapper>

  <!-- Fixed hover tooltip for truncated cells -->
  <div class="op-hovertip" *ngIf="hoverTip.show" [style.left.px]="hoverTip.x" [style.top.px]="hoverTip.y">
    {{ hoverTip.text }}
  </div>
</div>
